"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agile = void 0;
// import { ApplicationServices } from '../services/ApplicationServices';
class Agile {
    // private readonly endpointClient: EndpointClient;
    // constructor(instanceConfig?: EndpointRequestConfig) {
    //   const appServices = new ApplicationServices(instanceConfig);
    //   this.endpointClient = appServices.getEndpointClient();
    // }
    constructor(endpointClient) {
        this.endpointClient = endpointClient;
    }
    setConfigurations(configurations) {
        this.endpointClient.setConfigurations(configurations);
    }
    getConfigurations() {
        return this.endpointClient.getConfigurations();
    }
    request(config) {
        return this.endpointClient.request(config);
    }
    get(url, config) {
        return this.endpointClient.get(url, config);
    }
    delete(url, config) {
        return this.endpointClient.delete(url, config);
    }
    post(url, data, config) {
        return this.endpointClient.post(url, data, config);
    }
    put(url, data, config) {
        return this.endpointClient.put(url, data, config);
    }
    patch(url, data, config) {
        return this.endpointClient.patch(url, data, config);
    }
}
exports.Agile = Agile;
//# sourceMappingURL=Agile.js.map